import * as kea from "kea-react";
import * as React from "react";
import * as models from "app/models/requireme";

import { FacturasToolbarView } from "./view";
import { NuevoRepModal, NuevoRepModalValue } from "./pagos";
import { resources } from "app/main/std";
import { truncateDate } from "keautils";
import { esClaveCliente } from "app/logic/guias";


interface Props {
    idFacturas: number[];
    EsFacturaLogistica: boolean;
}

export class FacturasToolbar extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();
    onPagar = async () => {
        const idFacturas = this.props.idFacturas;
        const EsFacturaLogistica = this.props.EsFacturaLogistica;
        
        //Validar las facturas seleccionadas:
        const errorFacturas = await resources.Rep.ValidarFacturasNuevoRep(idFacturas);
        if(errorFacturas) {
            await kea.message("Facturas inválidas", errorFacturas, "error");
            return;
        }

        //Obtener los saldos de las facturas para inicializar los abonos:
        const facturas = await resources.Factura.Query({ Ids: idFacturas, EsFacturaLogistica:EsFacturaLogistica });
        const abonos = facturas.map<models.AbonoRepFactura>(x => ({
            IdFactura: x.IdRegistro,
            Monto: x.Saldo
        }));

        const value: NuevoRepModalValue = {
            facturas: this.props.idFacturas,
            EsFacturaLogistica: EsFacturaLogistica ,
            rep: {
                Facturas: abonos,
                IdRepSustituidos: [],
                Banco: {} as any,
                //FechaPago: truncateDate(new Date(), "days") as any,
                FechaPago: new Date(),
                FormaPago: null as any,
                IdSucursal: facturas[0].IdSucursal,
                IdBanco: null as any ,
                esRepLogistica: EsFacturaLogistica
            }
        };

        const res = await this.modalManager.showModal(NuevoRepModal, null, value );
        if(res.result) {
            //Crear el REP
            const idRep = await resources.Rep.CrearRep(res.value.rep);

            if(res.result == "timbrar") {
                await resources.Rep.TimbrarREP(idRep);
            }

            const folio = await resources.Rep.Get(idRep);
            await kea.message("REP creado", "Se creó el REP con folio " + folio.SerieFolio);
            location.reload();
        }
    }

    onTimbrar = () => {

    }

    render() {
        return (
            <>
                <FacturasToolbarView
                    cant={this.props.idFacturas.length}
                    onPagar={this.onPagar}
                    onTimbrar={this.onTimbrar}
                />
                {this.modalManager.component}
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/facturas/index.tsx